import Button from '../ui/Button.jsx';
import { Card, CardBody, CardFooter } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';
import { Col, Row } from '../ui/Layout.jsx';


const Contribution = ({ ...props }) => {
    const { heading, icon_img, subheading, inputs, button } = props;
    const { formData, fn } = props;

    const handleFormData = (name, value) => {
        console.log(formData);
        formData[name] = value;
        fn.handleFormChange(formData);
    };

    console.log(formData);
    return (
        <div className="component-contribution">
            <HeadingOne image={icon_img} heading={heading} />

            <Row justify="center">
                <Col lg="10/12">
                    <h2 className="text-center">{subheading}</h2>

                    <div className="relative">
                        {formData?.image ? (
                            <div className="contribution-image">
                                <img src={formData.image.path} />
                            </div>
                        ) : (
                            <div className="contribution-image-placeholder">Fotografie příspěvku</div>
                        )}
                        {formData?.title ? (
                            <div className="contribution-title"><h3>{formData.title.label}</h3></div>
                        ) : (
                            <div className="contribution-title-placeholder">Titulek příspěvku</div>
                        )}
                        {formData?.text ? (
                            <div className="contribution-text">{formData.text.text}</div>
                        ) : (
                            <div className="contribution-text-placeholder">Text příspěvku</div>
                        )}
                    </div>
                </Col>
            </Row>

            <Card>
                <CardBody>
                    <Row>
                        <Col lg="6/12">
                            <h3 className="mb-6">{inputs.title.label}</h3>
                            <div className="flex flex-col gap-6">
                                {inputs.title.items.map((item, index) => (
                                    <div
                                        key={index}
                                        className={'contribution-title-handle' + (formData?.title?.id == item.id ? ' --selected' : '')}
                                        onClick={() => handleFormData('title', item)}
                                    >
                                        {item.label}
                                    </div>
                                ))}
                            </div>
                        </Col>
                        <Col lg="6/12">
                            <h3 className="mb-6">{inputs.image.label}</h3>

                            <Row>
                                {inputs.image.items.map((item, index) => (
                                    <Col key={index} base="6/12" sm="4/12">
                                        <div
                                            className={'contribution-image-handle' + (formData?.image?.id == item.id ? ' --selected' : '')}
                                            onClick={() => handleFormData('image', item)}
                                        >
                                            <img src={item.path} />
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                        <Col>
                            <h3 className="mb-6">{inputs.text.label}</h3>
                            <div className="flex flex-col gap-6">
                                {inputs.text.items.map((item, index) => (
                                    <div
                                        key={index}
                                        className={'contribution-text-handle' + (formData?.text?.id == item.id ? ' --selected' : '')}
                                        onClick={() => handleFormData('text', item)}
                                    >
                                        {item.text}
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </CardBody>
                <CardFooter>
                    {button && (
                        <div className="mt-12">
                            <Button {...button} onClick={() => fn.handleAction(button.action)} />
                        </div>
                    )}
                </CardFooter>
            </Card>
        </div>
    );
};

export default Contribution;
